import { render, staticRenderFns } from "./superiorStaffHome.vue?vue&type=template&id=51d6ff30&scoped=true&"
import script from "./superiorStaffHome.vue?vue&type=script&lang=js&"
export * from "./superiorStaffHome.vue?vue&type=script&lang=js&"
import style0 from "./superiorStaffHome.vue?vue&type=style&index=0&id=51d6ff30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6ff30",
  null
  
)

export default component.exports